import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/** Platform-admin read of the deployment's transactional email configuration. */
export function useEmailSettings() {
  return useQuery({
    queryKey: queryKeys.emailSettings,
    queryFn: api.getEmailSettings,
  });
}
